export default
    {
        // url: this.$store.state.http.usuarios.YYYY,
        changepassword: "/usuarios/changepassword",
        changestatus: "/usuarios/changestatus",
        changeRoles: "/roles/change",
        consultaduplicado: "/usuarios/consultaduplicado",
        create: "/usuarios/create",
        list: "/usuarios/list",
        listRolesUsuario: "/roles/listRolesGrid",
        listRoles: "/usuarios/listRoles",
    }
